<template>
  <div>
    <div>
      <header
        class="d-flex justify-content-between align-items-center mt-2 w-100"
      >
        <span class="d-none d-md-flex font-weight-600 text-uppercase">
          {{ title }}
        </span>
        <span class="d-flex d-md-none font-weight-600 text-uppercase">
          {{ shortTitle || title }}
        </span>
        <atom-button
          v-if="hasUpdatePermission"
          button-id="btn-add"
          button-style="border"
          class="custom-button-width"
          @click="clickAdd"
        >
          <div class="d-flex justify-content-center align-items-center gap-4px">
            <feather-icon icon="PlusIcon" />
            <span class="d-none d-md-flex custom-padding-left-8">
              Add New {{ shortTitle }}
            </span>
          </div></atom-button
        >
      </header>

      <div
        v-if="!subPackageList.length"
        class="mt-1 item-box-border no-hover-effect d-flex align-items-center justify-content-center"
      >
        <span class="font-size-12">No {{ title }}</span>
      </div>

      <div v-else>
        <div
          v-for="(item, index) in subPackageList"
          :key="index"
          class="mt-1 item-box-border d-flex align-items-center"
        >
          <div class="w-15">
            <div class="d-flex justify-content-center">
              <span class="d-none d-sm-block font-size-8 text-uppercase">
                Sequence
              </span>
            </div>
            <div class="d-flex justify-content-center">
              <span class="d-block font-weight-600 font-size-10">
                #{{ item.sequence }}
              </span>
            </div>
          </div>
          <div class="w-40 text-wrap">
            <div class="d-flex justify-content-center">
              <span class="font-size-12 text-center">
                {{ item.period }}
              </span>
            </div>
          </div>
          <div class="w-35 text-wrap">
            <div class="d-flex justify-content-center">
              <span v-if="!infoIsArray" class="font-size-12 text-center">
                {{ item.info }} Baht
              </span>
              <div v-else>
                <ul class="pl-1 mb-0">
                  <li
                    class="font-size-12"
                    v-for="(subItem, index) in item.info"
                    :key="index"
                  >
                    {{ subItem }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="w-10">
            <div
              v-if="hasUpdatePermission"
              class="d-flex justify-content-center align-items-center cursor-pointer"
            >
              <feather-icon
                icon="Trash2Icon"
                @click="removeItem(index)"
              ></feather-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- * Start Modal -->
    <div>
      <molecule-modal-dialog
        :modalId="`${shortTitle}-modal-add-sub-package`"
        buttonTextLeft="Add new"
        buttonColorLeft="primary"
        :textTitle="`New ${title}`"
        :isSlotBody="true"
        :isCloseOnBackDrop="false"
        :isDisableButtonLeft="isDisable"
        @clickButtonLeft="clickConfirmAdd"
        @clickButtonRight="clickCancelAdd"
        @clickIconClose="clickCancelAdd"
      >
        <template #body>
          <div class="w-100 d-flex justify-content-center row">
            <div class="contract-period-sequence-container w-80 mt-1">
              <atom-input
                v-model="subPackageItem.sequence"
                title="Sequence"
                placeholder="Sequence"
                :errorMessage="
                  isErrorSequence
                    ? 'Please enter sequence'
                    : 'Sequence already exist'
                "
                :isError="isErrorSequence || isErrorCurrentSequenceInUse"
                :isAsterisk="true"
              />
            </div>
            <div class="contract-period-container w-80 mt-1">
              <atom-input
                v-model="subPackageItem.period"
                :title="periodText"
                :placeholder="periodText"
                errorMessage="Please enter contract period name"
                :isError="isErrorName"
                :isAsterisk="true"
              />
            </div>
            <div class="contract-period-container w-80 mt-1 mb-2">
              <atom-input
                v-if="!infoIsArray"
                v-model="subPackageItem.info"
                :title="infoName"
                :placeholder="infoName"
                :isAsterisk="true"
              />
              <div v-else>
                <label class="input-title">Sub Items</label>
                <div
                  v-for="(subitem, index) in subPackageItem.info"
                  :key="index"
                  class="my-1 d-flex justify-content-between align-items-center"
                >
                  <li>{{ subitem }}</li>
                  <div
                    class="delete-icon--container ml-2"
                    @click="clickDeleteInfoSubItem(index)"
                  >
                    <feather-icon
                      class="icon-size-20px"
                      icon="Trash2Icon"
                    ></feather-icon>
                  </div>
                </div>

                <div
                  class="d-flex"
                  :class="{ 'mt-1': subPackageItem.info.length }"
                >
                  <atom-input
                    v-model="newSubItem"
                    placeholder="Subitem"
                    errorMessage="Please enter subitem"
                  ></atom-input>
                  <atom-button
                    buttonId="add-new-subitem"
                    iconLeft="PlusIcon"
                    class="ml-2 h-100"
                    :isDisable="!newSubItem"
                    :isOnlyIcon="true"
                    @click="clickAddSubitem"
                  ></atom-button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </molecule-modal-dialog>
    </div>
    <!-- ! End Modal -->
  </div>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinObjectHelper from "@/mixins/mixinsObjectHelper"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"

export default {
  name: "MoleculeSubPackage",
  components: { AtomButton, AtomInput, MoleculeModalDialog },
  mixins: [mixinsValidator, mixinObjectHelper],
  props: {
    title: {
      type: String,
      required: true,
    },
    shortTitle: {
      type: String,
      required: true,
    },
    infoName: {
      type: String,
      required: false,
      default: "Price",
    },
    infoIsArray: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Array,
      required: true,
    },
    hasUpdatePermission: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["addSubPackage"],
  data() {
    return {
      modalId: null,
      subPackageItem: {
        id: null,
        sequence: null,
        period: "",
        info: this.infoIsArray ? [] : null,
      },

      isValidateSubPackageTrigger: false,

      newSubItem: null,
    }
  },
  computed: {
    subPackageList: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },

    periodText() {
      if (this.shortTitle === "Service") return "Package Item Name"
      if (this.shortTitle === "Add-On") return "Package Option Name"
      return "Package Period Name"
    },

    isDisable() {
      const isEmpty =
        !this.subPackageItem.sequence ||
        !this.subPackageItem.period ||
        !this.subPackageItem.info

      return Boolean(isEmpty || this.isError)
    },

    isError() {
      return Boolean(
        this.isErrorName ||
          this.isErrorSequence ||
          this.isErrorCurrentSequenceInUse
      )
    },

    isErrorName() {
      return Boolean(
        this.isValidateSubPackageTrigger &&
          this.isEmptyString(this.subPackageItem.period)
      )
    },

    isErrorSequence() {
      return Boolean(
        this.isValidateSubPackageTrigger &&
          this.isNotNumeric(this.subPackageItem.sequence)
      )
    },

    isErrorCurrentSequenceInUse() {
      return Boolean(
        this.isValidateSubPackageTrigger &&
          this.subPackageList
            .map((item) => item.sequence)
            .includes(this.subPackageItem.sequence)
      )
    },
  },
  watch: {
    subPackageItem: {
      deep: true,
      handler() {
        if (this.isError) {
          this.isValidateSubPackageTrigger = false
        }
      },
    },
  },
  mounted() {
    this.sortBySequence()
  },
  methods: {
    clickAdd() {
      this.isValidateSubPackageTrigger = true
      this.setDefaultItem()

      this.openModal(`${this.shortTitle}-modal-add-sub-package`)
    },

    removeItem(index) {
      this.subPackageList = this.subPackageList.toSpliced(index, 1)
    },

    clickConfirmAdd() {
      this.isValidateSubPackageTrigger = true

      this.$nextTick(() => {
        if (!this.isError) {
          this.isValidateSubPackageTrigger = false
          this.subPackageList.push(this.subPackageItem)

          this.sortBySequence()

          this.$emit("addSubPackage", this.shortTitle, this.subPackageList)

          this.closeModal()
        }
      })
    },

    clickCancelAdd() {
      this.isValidateSubPackageTrigger = false
      this.closeModal()
    },

    setDefaultItem() {
      this.subPackageItem = this.deepCopyObject({
        id: null,
        sequence: null,
        period: "",
        info: this.infoIsArray ? [] : null,
      })
    },

    sortBySequence() {
      this.subPackageList.sort((a, b) =>
        a.sequence > b.sequence ? 1 : b.sequence > a.sequence ? -1 : 0
      )
    },

    clickDeleteInfoSubItem(index) {
      this.subPackageItem.info = this.subPackageItem.info.toSpliced(index, 1)
    },

    clickAddSubitem() {
      this.subPackageItem.info.push(this.newSubItem)

      this.newSubItem = null
    },

    /**
     * ? Modal
     */
    openModal(modalId) {
      this.isValidateSubPackageTrigger = false

      this.modalId = modalId
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.setDefaultItem()
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },
  },
}
</script>

<style lang="scss" scoped>
.gap-4px {
  gap: 4px;
}

.item-box-border {
  border-radius: 6px;
  border: 1px solid #ebe9f1;
  min-height: 46px;
  width: 100%;
  padding: 10px;
}

.input-title {
  color: #5e5873;
  font-size: 12px;
  line-height: 1.5;
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .item-box-border {
    width: 100%;
  }
}
</style>
